<template>
  <BasePopUp @popupClosed="closePopUp()" :showpopup="showpopup_video">
    <div class="popup-container">
      <div class="logo-container">
        <img src="../../assets/uhive-logo-blue.svg" class="uhive_logo_popup" />
      </div>
      <div class="message">
        <p>To Continue watching the rest of this video open Uhive application</p>
      </div>
      <div class="button-container">
        <a :href="getLink()" class="Download-Uhive-App">Continue Watching</a>
      </div>
    </div>
  </BasePopUp>
</template>
<script>
import BasePopUp from "./base.vue";

export default {
  name: "ContinueWatchingPopUp",
  components: {
    BasePopUp: BasePopUp,
  },
  methods: {
    getLink() {
      let ua = navigator.userAgent;
      let isAndroid = /(android)/i.test(ua);
      if (isAndroid) {
        let intent = `${window.location.host}${window.location.pathname}`;
        return `intent://${intent}#Intent;scheme=https;package=uhiveapp.uhive.com.uhive;S.browser_fallback_url=https%3A%2F%2Fplay.google.com/store/apps/details?id=uhiveapp.uhive.com.uhive;end`;
      } else if (
        /iPad|iPhone|iPod/.test(ua) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
      ) {
        return `https://uhive.page.link/?link=https://rt.uhive.com/deeplink${encodeURIComponent('?action=OpenPost&m=' + window.location.pathname.substring(window.location.pathname.indexOf("/m") + 3))}&apn=uhiveapp.uhive.com.uhive&ibi=com.uhive.uhive&isi=1441517158&ifl=https://apps.apple.com/app/id1441517158&ipfl=https://apps.apple.com/app/id1441517158&efr=1`;
      } else {
        return "https://www.uhive.com/download";
      }
    },
    closePopUp() {
      this.$emit("popupClosed");
      this.showpopup = false;
      this.$store.dispatch(
        "shares/setVideToResumeNow_Action",
        this.$store.getters["shares/get_video_paused_from_popup"]
      );
      this.$store.dispatch("shares/clear_VideoPauseFromPopUp_Action");
    },
  },
  props: {
    showpopup_video: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>


.popup-container{ 
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 1rem 1rem 1rem 1rem ;
}
.message p{ 
  font-size: 1.5rem;
  font-weight: 500;
}

.uhive_logo_popup{ 
  width: 10rem;
}

.Download-Uhive-App {
  width: 70%;
  padding: 10px 20px 10px 20px !important;
  border-radius: 55px !important;
  background-color: #2979fc;
  text-align: center !important;
  font-size: 2.2vh !important;
  color: #fff;
  text-decoration: none !important;
}



@media only screen and (max-width: 350px), screen and (max-height: 650px) {
.message p{ 
  font-size: 1rem;
  font-weight: 500;
}
.popup-container{ 
  gap: 1rem;
}

.uhive_logo_popup{ 
  width: 7rem;
}
}
@media only screen and (max-height: 350px) {
.popup-container{ 
  gap: 0.5rem;
}

.uhive_logo_popup{ 
  width: 3.5rem;
}
}
</style>